import { render, staticRenderFns } from "./dash-card.vue?vue&type=template&id=01543123&scoped=true&"
import script from "./dash-card.vue?vue&type=script&lang=ts&"
export * from "./dash-card.vue?vue&type=script&lang=ts&"
import style0 from "./dash-card.vue?vue&type=style&index=0&id=01543123&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01543123",
  null
  
)

export default component.exports